<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link v-if="storeEnabled" :to="{ path: `/patient/${patient.id}/caregivers/add` }"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          {{ $t('cta.add_caregiver') }}
          <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <SpinnerLoading v-if="caregivers === undefined" class="mt-50" />
      <p v-if="caregivers.length === 0" class="m-0">
        {{ $t('feature.$caregivers.no_caregivers') }}
      </p>
      <div class="table-responsive" v-else>
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ID
              </th> -->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('form.first_name.label') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('form.last_name.label') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('form.email.label') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('form.phone.label') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- CENTER ROW -->
            <tr v-for="caregiver in caregivers" :key="'caregiver_' + caregiver.id">
              <!-- <td class="shadow-none lh-1 fw-medium text-primary" @click="show(caregiver)">
                {{ caregiver.id }}
              </td> -->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" @click="show(caregiver)">
                {{ caregiver.firstname }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis  pe-0" @click="show(caregiver)">
                {{ caregiver.lastname }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary  pe-0" @click="show(caregiver)">
                {{ caregiver.email }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary  pe-0" @click="show(caregiver)">
                {{ caregiver.phone_number }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end" v-if="destroyEnabled">
                <div class="dropdown position-static">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" data-bs-boundary="viewport">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- <li>
                      <router-link :to="{ path: `/center/${caregiver.id}` }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="ph ph-eye lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.view') }}
                      </router-link>
                    </li> -->
                    <!-- <li>
                      <router-link :to="{ path: `/patient/${patient.id}/caregivers/${caregiver.id}/edit` }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="ph-duotone ph-pencil lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.edit') }}
                      </router-link>
                    </li> -->
                    <li>
                      <button class="dropdown-item d-flex align-items-center"
                        v-on:click="confirmDeleteCaregiver(caregiver)">
                        <i class="ph ph-trash lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.delete') }}
                      </button>
                    </li>
                    <!-- <li>
                      <button class="dropdown-item d-flex align-items-center"
                        v-on:click="(e) => recoveryPassword(user, e)">
                        <span v-if="recovery_loading" class="spinner-border spinner-border-xs border-1 me-8"
                          role="status" aria-hidden="true"></span>
                        <i v-else class="ph ph-arrow-clockwise lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.recovery_password') }}
                      </button>
                    </li> -->
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- PAGINATION -->
      <!-- <TablePagination :count="centers?.length ?? 0" :page="currentPage" :total="total" :pages="lastPage"
        @change="setPage($event)" /> -->
    </div>
  </div>
  <ConfirmModal @confirm="deleteCaregiver()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import API from "@/services/api/api.service";
import { Modal } from "bootstrap";
import { PatientInfo, Role, UserInfo } from "@/utils/models/user.model";
import CONFIG from "@/utils/const/config"
import stateStore from "@/utils/store";


export default defineComponent({
  name: "CaregiversList",
  data() {
    return {
      patient: this.$route.meta.patient as PatientInfo,
      confirmModal: null,
      selectedCaregiver: null
    } as {
      patient: PatientInfo,
      confirmModal: Modal | null,
      selectedCaregiver: UserInfo | null;
    }
  },
  mounted() {
    this.confirmModal = new Modal('#confirmModal', {})
  },
  computed: {
    config() { return CONFIG },
    caregivers(): UserInfo[] { return this.patient.users?.filter((info) => info.role.type === Role.caregiver) ?? []; },
    storeEnabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'store') },
    destroyEnabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'destroy') },
  },
  methods: {
    confirmDeleteCaregiver(caregiver: UserInfo) {
      this.selectedCaregiver = caregiver;
      this.confirmModal?.show();
    },
    deleteCaregiver(): void {
      API.deleteCaregiver({ patient_id: this.patient.id!, caregiver_id: this.selectedCaregiver?.id! }).then((response) => {
        if (response.data.success === true) {
          let index = this.patient.users?.findIndex((val) => val.id === this.selectedCaregiver?.id);
          if (index) {
            console.log(index);
            this.patient.users?.splice(index, 1);
            console.log(this.caregivers);
          }
          this.selectedCaregiver = null;
        }
      }).finally(() => {
        console.log("DELETED_CAREGIVER_ID", this.selectedCaregiver?.id);
      })
    },
    show(caregiver: UserInfo) {
      return;
      this.$router.push({ path: `/patient/${this.patient.id}/caregivers/${caregiver.id}/edit` });
    },
  },
  components: {
    ConfirmModal,
    SpinnerLoading,
  }
});
</script>